import { render, staticRenderFns } from "./Apoderados.vue?vue&type=template&id=146fef35&scoped=true"
import script from "./Apoderados.vue?vue&type=script&lang=js"
export * from "./Apoderados.vue?vue&type=script&lang=js"
import style0 from "./Apoderados.vue?vue&type=style&index=0&id=146fef35&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146fef35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('146fef35')) {
      api.createRecord('146fef35', component.options)
    } else {
      api.reload('146fef35', component.options)
    }
    module.hot.accept("./Apoderados.vue?vue&type=template&id=146fef35&scoped=true", function () {
      api.rerender('146fef35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/Apoderados.vue"
export default component.exports